import { render, staticRenderFns } from "./distpicker.vue?vue&type=template&id=dec2386e&scoped=true"
import script from "./distpicker.vue?vue&type=script&lang=js"
export * from "./distpicker.vue?vue&type=script&lang=js"
import style0 from "./distpicker.vue?vue&type=style&index=0&id=dec2386e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec2386e",
  null
  
)

export default component.exports